import React, { useEffect, useState } from 'react';
// import { useMatomo } from '@datapunt/matomo-tracker-react'
import { clsx } from 'clsx';
import Cookies from 'js-cookie'

'use strict';

function RundedrehenNewsletterPopup({ delay }) {
  // const { trackEvent } = useMatomo();
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (!Cookies.get('hideNewsletterPopup')) {
      setTimeout(() => {
        setActive(true);
      }, delay);
    }
  });

  const handleClose = () => {
    setActive(false);
    Cookies.set('hideNewsletterPopup', 1, { expires: 14 });
  };


  return !Cookies.get('hideNewsletterPopup') && <div className={clsx(`
    bg-neutral_d rounded-lg md:bg-transparent
    absolute
    bottom-0 md:bottom-[calc(43.5vh+2rem)] lg:bottom-auto lg:top-20
    md:right-4 lg:right-24
    w-full md:max-w-lg
    p-3 md:p-4 lg:p-2
    z-[500]
    transition-[opacity,visibility]
  `,
    {'visible': active},
    {'opacity-100': active},
    {'invisible': !active},
    {'opacity-0': !active},
  )}>
    <div className="
      bg-white rounded lg:rounded-lg text-neutral_d
      relative
      p-3 md:p-4
    ">
      <p className="
        font-bold
        text-base md:text-base+ lg:text-lg mb-0.5
      ">
        Die Grouprides in Deiner Stadt
      </p>
      <p className="
        text-sm md:text-tiny
      ">
        … jeden Monat in Deinem Posteingang? Kein Ding mit unserem Newsletter!
        <a href="/grouprides/all" className="
          block mt-4 md:mt-6 w-full text-center
          font-black uppercase tracking-wide
          px-2 md:px-6 py-2 md:py-2 rounded md:rounded-md
          cursor-pointer select-none
          text-white bg-neutral_d
          after:content-[''] after:absolute after:inset-0 after:top-4 after:z-10
          outline outline-2 outline-offset-2 outline-transparent active:outline-primary focus:outline-primary hover:outline-primary_d transition-colors
        ">
          Newsletter abonnieren
        </a>
      </p>

      <button onClick={handleClose} className="
        absolute z-[600] top-0 right-0 p-2
      " title="Schließen">
        <div className="
          text-sm rounded bg-neutral_d text-white
          font-bold w-6 h-6 flex justify-center items-center
        ">
          <span className="-translate-y-px">×</span>
        </div>
      </button>
    </div>
  </div>;
}


export default RundedrehenNewsletterPopup;
